import React from "react";
import "./Scrapbook.scss";
import SideNav from "../SideNav/SideNav";
import Editor from "./Editor/Editor";
import { Parts } from "../Write";
import { useState } from "react";
import { useEffect } from "react";
import Cookies from "js-cookie";
import config from "../../../config/apiConfig";

type Props = {
    storyId: string;
    parts: Parts;
    setParts: (arg: Parts) => void;
    scrapVisible: boolean;
    closeScrap: () => void;
};

const Scrapbook: React.FC<Props> = (props) => {
    const [parts, setParts] = useState(props.parts);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!!props.parts.id) {
            const formData = new FormData();
            formData.append("session-token", Cookies.get("token") ?? "");
            formData.append("token", config.token);
            const requestParams = {
                method: "POST",
                body: formData,
            };
            setIsLoading(true);
            fetch(
                config.BASE_URL +
                    "/v1/get/writingtool/story/" +
                    props.storyId +
                    "/chapter/" +
                    props.parts.id +
                    "/info",
                requestParams
            )
                .then((res) => res.json())
                .then((res) => {
                    const newPart = { ...props.parts };
                    newPart.body = !!res.data?.body
                        ? {
                              raw: JSON.parse(res.data.body.raw),
                              html: res.data.body.html,
                          }
                        : {};
                    setParts({ ...newPart });
                })
                .finally(() => setIsLoading(false));
        }
    }, [props.parts.id]);

    useEffect(() => {
        setParts(props.parts);
    }, [props.parts.id, props.parts.title]);

    return (
        <div className="scrapbook_section">
            <SideNav show={props.scrapVisible} toggle={props.closeScrap} />
            <main>
                <div className="editor">
                    <div
                        className="content-editable"
                        contentEditable={true}
                        spellCheck={true}
                        placeholder="Write title"
                        onBlur={(event: any) => {
                            let newPart = Object.assign({}, props.parts);
                            newPart.title = event.target.innerText;
                            setParts(newPart);
                            props.setParts(newPart);
                        }}
                    >
                        {parts.title}
                    </div>
                    <div className="horizontal-divider"></div>
                    <Editor parts={parts} setParts={props.setParts} />
                </div>
            </main>
        </div>
    );
};

export default Scrapbook;
